import { Search, RefreshCw, PlusCircle, Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";

export function ContactsPage() {
  const contacts = [
    {
      id: 1,
      name: "Sophie Martin",
      email: "sophie.martin@email.com",
      phone: "+33 6 12 34 56 78",
      children: 2,
      status: "active",
      avatar: "/api/placeholder/40/40",
    },
    {
      id: 2,
      name: "Pierre Durand",
      email: "pierre.durand@email.com",
      phone: "+33 6 98 76 54 32",
      children: 1,
      status: "active",
      avatar: "/api/placeholder/40/40",
    },
    {
      id: 3,
      name: "Marie Leblanc",
      email: "marie.leblanc@email.com",
      phone: "+33 6 11 22 33 44",
      children: 3,
      status: "inactive",
      avatar: "/api/placeholder/40/40",
    },
  ];

  return (
    <>
      <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
        <h1 className="text-2xl font-bold text-gray-800">Contacts</h1>
        <div className="flex items-center space-x-4">
          <div className="relative w-80">
            <Search className="absolute top-1/2 left-3 -translate-y-1/2 transform text-gray-400" size={18} />
            <Input placeholder="Rechercher un contact..." className="w-full rounded-lg border border-gray-300 py-2 pr-4 pl-10" />
          </div>
          <Button variant="outline" size="icon" className="h-10 w-10">
            <RefreshCw size={18} />
          </Button>
          <Button className="bg-blue-500 text-white hover:bg-blue-600">
            <PlusCircle size={18} className="mr-2" />
            Nouveau Contact
          </Button>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-6">
        <div className="grid gap-4">
          {contacts.map((contact) => (
            <Card key={contact.id}>
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <Avatar className="h-12 w-12">
                      <AvatarImage src={contact.avatar} alt={contact.name} />
                      <AvatarFallback>
                        {contact.name
                          .split(" ")
                          .map((n) => n[0])
                          .join("")}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <h3 className="font-semibold text-gray-900">{contact.name}</h3>
                      <div className="flex items-center space-x-4 text-sm text-gray-600">
                        <div className="flex items-center">
                          <Mail size={14} className="mr-1" />
                          {contact.email}
                        </div>
                        <div className="flex items-center">
                          <Phone size={14} className="mr-1" />
                          {contact.phone}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="text-right">
                      <p className="text-sm font-medium">{contact.children} enfant(s)</p>
                      <Badge variant={contact.status === "active" ? "default" : "secondary"} className="mt-1">
                        {contact.status === "active" ? "Actif" : "Inactif"}
                      </Badge>
                    </div>
                    <Button variant="outline" size="sm">
                      Voir détails
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </>
  );
}
